import React from 'react';

import { createRoot } from 'react-dom/client';

import { updateMetricByKey } from '@client/core/atoms/metrics.js';
import { updatePlacementKeyValueById } from '@client/core/atoms/placements.js';
import { i18n } from '@lingui/core';
import {
  type PlacementId,
  PlacementStatus
} from '@schibsted-nmp/advertising-shared';

import { SponsoredListingAd } from './ads/PlaceholderAds.js';

const martailerRequest = (container: PlacementId) => {
  updatePlacementKeyValueById(container, 'status', 'requested');
  updatePlacementKeyValueById(container, 'creativeType', 'banner');
  updateMetricByKey(container, PlacementStatus.AdLoaded);
  updatePlacementKeyValueById(container, 'status', 'loaded');

  renderMartailerPlaceholder(container);
};

export function triggerMartailerRequest(container: PlacementId) {
  martailerRequest(container);
}

function renderMartailerPlaceholder(placementId: PlacementId) {
  setTimeout(() => {
    const slotElement = document.getElementById(placementId);
    if (!slotElement) {
      console.log('Slot element not found:', placementId);
      return;
    }

    // Clear the slot
    slotElement.innerHTML = '';
    slotElement.style.gridColumn = '1 / 1';

    const originalLocale = i18n.locale;
    console.log(originalLocale);
    const supportedLocale = ['fi', 'nb', 'da'].includes(i18n.locale)
      ? i18n.locale
      : 'nb'; // Default to Norwegian

    if (originalLocale !== supportedLocale) {
      i18n.activate(supportedLocale);
    }

    // Create a container for the React component
    const container = document.createElement('div');
    slotElement.appendChild(container);

    // Render the React component into the container
    const root = createRoot(container);
    root.render(<SponsoredListingAd layout="grid" />);

    if (originalLocale !== supportedLocale) {
      setTimeout(() => i18n.activate(originalLocale), 0);
    }
  }, 1);
}
